import { Text } from "components/Text"
import * as React from "react"
import PropTypes from "prop-types"
import { NestableList } from "components/NestableList"
import { useTranslator } from "components/Translator"
import cx from "classnames"

export const DescriptionItem = ({
  label,
  value,
  id: manualId,
  direction = "row",
}) => {
  const autoId = `DescriptionItem-${React.useId()}`
  const id = manualId || autoId

  const translator = useTranslator()

  return (
    <div
      className={cx(
        {
          "flex-col space-y-4": direction === "column",
          "flex-row space-x-4": direction === "row",
        },
        "flex justify-between ",
      )}
    >
      <Text
        className="text-light leading-loose lg:leading-normal"
        variant="subtitle2"
        tag="dt"
        id={id}
      >
        {label}
      </Text>
      <Text
        className="text-default"
        variant="body2"
        tag="dd"
        aria-labelledby={id}
      >
        {Array.isArray(value) ? (
          value.length > 1 ? (
            <NestableList>
              {value.map((value, index) => {
                const finalValue = getFinalValue(value, translator)
                return (
                  <Text
                    key={index}
                    className="text-default"
                    variant="body2"
                    tag="li"
                    aria-label={finalValue}
                  >
                    {finalValue}
                  </Text>
                )
              })}
            </NestableList>
          ) : value.length > 0 ? (
            <ul>
              {value.map((value, index) => {
                const finalValue = getFinalValue(value, translator)
                return (
                  <Text
                    key={index}
                    className="text-default"
                    variant="body2"
                    tag="li"
                    aria-label={finalValue}
                  >
                    {finalValue}
                  </Text>
                )
              })}
            </ul>
          ) : (
            translator.trans("DescriptionItem.none", null, "components")
          )
        ) : (
          getFinalValue(value, translator)
        )}
      </Text>
    </div>
  )
}

DescriptionItem.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.array,
    PropTypes.shape({ enum_label: PropTypes.string.isRequired }),
    PropTypes.bool,
  ]),
  id: PropTypes.string,
  direction: PropTypes.oneOf(["row", "column"]),
}

/**
 * @param {[string|boolean|number|React.ReactElement]} value
 * @returns {string}
 */
const getFinalValue = (value, translator) => {
  if (value === null || value === undefined) {
    return "NC"
  }

  if (typeof value === "boolean") {
    return translator.trans(
      value ? "DescriptionItem.yes" : "DescriptionItem.no",
      null,
      "components",
    )
  }

  if (typeof value === "string" && value) {
    return value
  }

  if (React.isValidElement(value)) {
    return value
  }

  if (typeof value === "number") {
    return value
  }

  return value.enum_label || "NC"
}
